import React from 'react'
import classnames from 'classnames'

import List from '../List/List'
import RichText from '../RichText/RichText'

import { section, top, img as image, desc } from './PageFooter.module.scss'

const PageFooter = ({ data, className, ...props }) => {
  const { img, title, footerList, description } = data

  return (
    <div className={classnames(section, className)} {...props}>
      <div className={top}>
        <div className={image}>
          <img
            src={img.sourceUrl}
            srcSet={img.srcSet}
            alt={img.altText}
            width={img.mediaDetails.width}
            height={img.mediaDetails.height}
          />
        </div>
        <div>
          {title && <h2>{title}</h2>}
          {footerList && (
            <List
              items={footerList.items.map((item) => item.text)}
              columns={1}
              large={footerList.size === 'large'}
            />
          )}
        </div>
      </div>
      {description && <RichText className={desc}>{description}</RichText>}
    </div>
  )
}

export default PageFooter
